import { HostListener } from "@angular/core";
import { Directive, Input } from "@angular/core";

@Directive({
    selector: "[emailTo]",
    standalone: false
})
export class EmailToDirective{
    @Input("emailTo") email:string;

    @HostListener("click")
    onClick(){
        location.href=`mailto:${this.email}`
    }
}